export default "__VITE_ASSET__DoentBtV__"